import { z } from "zod/v4";

import { ShopifyGqlIdType } from "../dtos/shopify-product-variants";

export type MetafieldNamespace = "intelligems" | "seo";

export const IgMetafieldSchema = z.object({
  id: z.string(),
  legacyResourceId: z.string().optional(),
  key: z.string().optional(),
  jsonValue: z.any(),
});

export interface IgMetafield<T> {
  __typename?: "Metafield" | undefined;
  id: string;
  owner?: {
    id: string;
  };
  legacyResourceId?: string;
  key?: string;
  jsonValue: T;
}

export type MetafieldEventBridgeEventSharedPayload = {
  ownerId: string;
  ownerType: ShopifyGqlIdType;
  key: string;
  shopId: string;
  namespace: MetafieldNamespace;
};
export type MetafieldDeleteEventBridgePayload =
  MetafieldEventBridgeEventSharedPayload & {
    metafieldId: string;
    action: "delete";
  };

export type MetafieldSetEventBridgePayload =
  MetafieldEventBridgeEventSharedPayload & {
    action: "set";
    value: string;
  };

export type MetafieldEventBridgePayload =
  | MetafieldDeleteEventBridgePayload
  | MetafieldSetEventBridgePayload;
